import { AddIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Container,
  Flex,
  FormControl,
  Heading,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Spinner,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { Select } from "chakra-react-select";
import { default as React, useEffect, useState } from "react";
import { fetchTags } from "../../api/resources";
import { Context } from "../../ContextWrapper";
import CustomTableContainer from "../../theme/components/tableContainer";
import { ResourceTagManagment } from "./tagAdmin";

export const ResourcesCategory = () => {
  const [loading, setLoading] = useState(true);
  const [resourceList, setResourceList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [currentCategory, setCurrentCategory] = useState({});
  const [toggleItems, setToggleItems] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState();
  const [toggleTags, setToggleTags] = useState(false);

  const context = React.useContext(Context);

  useEffect(() => {
    const refreshResources = () => {
      const url = `/api/v2/resourcecategories/`;
      axios
        .get(
          url,
          { headers: { "Content-Type": "application/json" } },
          { withCredentials: true }
        )
        .then((res) => {
          setResourceList(res.data);
        })
        .catch((err) => console.log(err));
    };

    refreshResources();
    setLoading(false);
  }, []);

  const toggle = () => {
    setCurrentCategory({});
    setIsModalOpen(!isModalOpen);
  };

  const startCreateResourceCategories = () => {
    setCurrentCategory({});
    setIsModalOpen(true);
  };

  const startUpdateResourceCategories = (resourceCategoryData) => {
    setCurrentCategory(resourceCategoryData);
    setIsModalOpen(true);
  };

  const toggleDelete = () => {
    setCurrentCategory({});
    setIsDeleteModalOpen(!isDeleteModalOpen);
  };

  const startDeleteResourceCategories = (resourceCategoryData) => {
    setCurrentCategory(resourceCategoryData);
    setIsDeleteModalOpen(true);
  };

  const toggleView = () => {
    setToggleItems(true);
  };

  const handleSubmit = async (event, resource) => {
    event.preventDefault();
    setLoading(true);

    const formData = new FormData();

    formData.append("tag", resource.tag);

    formData.append("description", resource.description);
    formData.append("name", resource.name);

    let url = `/api/v2/resourcecategories/`;

    try {
      let res;
      if (resource.id) {
        url += `${resource.id}/`;
        res = await axios.patch(url, formData);

        if (res.status < 300) {
          setResourceList(
            resourceList.map((o) => (o.id === res.data.id ? res.data : o))
          );
          context.fireToast("Success", "Resource has been updated", "success");
          toggle();
        } else {
          context.fireToast("Error", res.request.responseText, "error");
        }
      } else {
        res = await axios.post(url, formData);

        if (res.status < 300) {
          setResourceList([...resourceList, res.data]);
          context.fireToast("Success", "Resource added", "success");
          toggle();
        } else {
          context.fireToast("Error", res.request.responseText, "error");
        }
      }
    } catch (err) {
      console.error("There was an error updating the resource!", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (resourceCategoryData) => {
    let url = `/api/v2/resourcecategories/`;

    url += `${resourceCategoryData.id}/`;

    axios
      .delete(url)
      .then((res) => {
        if (res.status < 300) {
          setResourceList(
            resourceList.filter((o) => o.id !== resourceCategoryData.id)
          );
          context.fireToast("Success", "Resource has been deleted", "success");
        } else {
          context.fireToast("Error", res.request.responseText, "error");
        }
        setLoading(false);
        toggleDelete();
      })
      .catch((err) => console.log(err));
  };

  return (
    <Container maxW="100%" bg="brand.50" h="calc(91vh)">
      {!toggleItems && !toggleTags && (
        <>
          {loading && (
            <FontAwesomeIcon
              className="float-end fa-spin"
              icon={faSpinner}
              color="green"
            />
          )}
          <Stack direction="column" spacing={2} align="center">
            <CustomTableContainer width="100%">
              <ResourceCategoryModal
                isOpen={isModalOpen}
                toggle={toggle}
                title="Focus Area"
                resourceCategoryData={currentCategory}
                loading={loading}
                handleSubmit={handleSubmit}
              />
              <ResourceCategoryDeleteModal
                colorScheme="red"
                isOpen={isDeleteModalOpen}
                toggle={toggleDelete}
                resourceCategoryData={currentCategory}
                loading={loading}
                handleDelete={handleDelete}
              />
              <Flex pb="5">
                <Box>
                  <Heading as="h3" size="lg">
                    Focus Areas
                  </Heading>
                </Box>
                <Spacer />
                <Box>
                  <HStack direction="row" spacing={6} align="center">
                    <Button onClick={() => setToggleTags(true)}>
                      Manage Resource Tags
                    </Button>
                    <Button
                      onClick={startCreateResourceCategories}
                      leftIcon={<AddIcon boxSize={3} />}
                    >
                      Create Focus Area
                    </Button>
                  </HStack>
                </Box>
              </Flex>
              <Box
                maxHeight="calc(100vh - 350px)"
                bg="white"
                overflowY={"auto"}
              >
                <Table variant="unstyled" overflowY={"auto"}>
                  <Thead position="sticky" top={-1} zIndex={1}>
                    <Tr>
                      <Th>Focus Area</Th>
                      <Th>Action</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {resourceList.map((resource) => (
                      <ResourceCategoryRow
                        key={resource.id}
                        resourceCategoryData={resource}
                        startUpdateResourceCategories={
                          startUpdateResourceCategories
                        }
                        toggle={toggleView}
                        category={setSelectedCategory}
                        startDeleteResourceCategories={
                          startDeleteResourceCategories
                        }
                      />
                    ))}
                  </Tbody>
                </Table>
              </Box>
            </CustomTableContainer>
          </Stack>
        </>
      )}{" "}
      {toggleTags && <ResourceTagManagment toggle={setToggleTags} />}
    </Container>
  );
};

const ResourceCategoryRow = ({
  resourceCategoryData,
  startUpdateResourceCategories,
  toggle,
  category,
  startDeleteResourceCategories,
}) => {
  return (
    <>
      <Tr key={resourceCategoryData.id}>
        <Td>{resourceCategoryData.name}</Td>
        <Td>
          <HStack spacing={2}>
            <Button
              onClick={() =>
                startUpdateResourceCategories(resourceCategoryData)
              }
            >
              Edit
            </Button>
            <Button
              colorScheme="red"
              onClick={() =>
                startDeleteResourceCategories(resourceCategoryData)
              }
            >
              Delete
            </Button>
          </HStack>
        </Td>
      </Tr>
    </>
  );
};

const ResourceCategoryDeleteModal = ({
  isOpen,
  toggle,
  resourceCategoryData,
  loading,
  handleDelete,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={toggle}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Focus Area</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          Are you sure you want to delete this Focus Area{" "}
          {resourceCategoryData.name}?
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="red"
            onClick={() => handleDelete(resourceCategoryData)}
            isDisabled={loading}
          >
            {loading ? "Processing..." : "Delete"}
          </Button>
          <Button onClick={toggle} ml={3}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const ResourceCategoryModal = ({
  isOpen,
  toggle,
  title,
  resourceCategoryData,
  loading,
  handleSubmit,
}) => {
  const confirmText = !resourceCategoryData.id ? "Create" : "Update";
  const [resourceData, setResourceData] = useState({
    name: "",
    description: "",
    resource_title: "",
    resource_description: "",
    external_link: "",
    video_duration: "",
    tags: [],
    card_image: "",
    resource_file: "",
  });
  const [tagList, setTagList] = useState([]);

  useEffect(() => {
    if (isOpen) {
      setResourceData({
        name: "",
        description: "",
      });
    }
  }, [isOpen]);

  useEffect(() => {
    setResourceData({
      ...resourceCategoryData,
      name: resourceCategoryData.name || "",
      description: resourceCategoryData.description || "",
    });
  }, [resourceCategoryData]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchTags();
      setTagList(data);
    };
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setResourceData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    handleSubmit(e, resourceData);
  };

  const tagOptions = tagList.map((tag) => ({
    value: tag.id,
    label: tag.name,
  }));

  const handleSelect = (selectedOption) => {
    setResourceData((prev) => ({
      ...prev,
      tag: selectedOption.value,
    }));
  };

  return (
    <Modal isOpen={isOpen} onClose={toggle}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{confirmText + " " + title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody maxHeight={"700px"} minH={"600px"} overflowY="auto">
          <form id="ResourceCategoryForm" onSubmit={handleFormSubmit}>
            <FormControl>
              <Text
                fontSize="20px"
                textDecoration={"underline"}
                padding={"10px 0px"}
              >
                {"FA Title"}
              </Text>
              <Input
                required
                type="text"
                name="name"
                placeholder="Determines search for importing targets."
                value={resourceData.name}
                onChange={handleInputChange}
              />
            </FormControl>

            <FormControl>
              <Text
                fontSize="20px"
                textDecoration={"underline"}
                padding={"10px 0px"}
              >
                {"FA Description"}
              </Text>
              <Input
                required
                type="text"
                name="description"
                placeholder="Determines description of FA on account dashboard."
                value={resourceData.description}
                onChange={handleInputChange}
              />
            </FormControl>

            <FormControl isRequired>
              <Text
                fontSize="20px"
                textDecoration="underline"
                padding="10px 0px"
              >
                Assign Tag to Focus Area
              </Text>
              <Select
                required
                name="tag"
                options={tagOptions}
                value={tagOptions.find((opt) => opt.value === resourceData.tag)}
                onChange={handleSelect}
                placeholder="Select a tag"
                closeMenuOnSelect={true}
                styles={{
                  container: (base) => ({ ...base, width: "100%" }),
                }}
              />
            </FormControl>
          </form>
        </ModalBody>

        <ModalFooter>
          <Button
            onClick={toggle}
            isDisabled={loading}
            colorScheme="blackAlpha"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            form="ResourceCategoryForm"
            isDisabled={loading}
            ml={3}
          >
            {loading ? <Spinner size="sm" /> : confirmText}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
